import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useActivities } from "./useActivities";
import { Gantt } from "@/components/Gantt";
import { PageLoader } from "@/components/ui";
import { ActivityDrawer } from "./ActivityDrawer";
import type { ProjectBundle } from "../ProjectDetail";

export function GanttView({ bundle }: { bundle: ProjectBundle }) {
  const { data: activities, isLoading } = useActivities(bundle.project.id);
  const [params, setParams] = useSearchParams();
  const [group, setGroup] = useState(true);
  const selected = activities?.find((a) => a.id === params.get("activity")) || null;

  if (isLoading) return <PageLoader />;

  return (
    <>
      <div className="mb-3 flex items-center justify-between">
        <p className="text-sm text-ink-soft">
          Weekly timeline · {bundle.project.ganttWeeks} weeks from {bundle.project.ganttStart?.slice(0, 10) || "project start"}
        </p>
        <label className="flex items-center gap-1.5 text-xs">
          <input type="checkbox" checked={group} onChange={(e) => setGroup(e.target.checked)} /> Group by phase
        </label>
      </div>
      <Gantt
        activities={activities ?? []}
        ganttStart={bundle.project.ganttStart}
        weeks={bundle.project.ganttWeeks}
        groupByPhase={group}
        onSelect={(a) => setParams({ activity: a.id })}
      />
      {selected && <ActivityDrawer activity={selected} bundle={bundle} onClose={() => setParams({})} />}
    </>
  );
}
